<div class="modal-header ">
  <h4 class="modal-title header-13">
    {{ configs.title }}
  </h4>
 <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        "
      />
    </button>
</div>

<div class="modal-body ">
  <div class="w-100 d-flex flex-column">
    <div class="sample-file w-100 d-flex flex-column mb-3">
      <div
        class="d-flex flex-row align-items-center justify-content-space-between gap-2"
      >
        <span class="accello-general-text4">
          ** Upload Raw Test Case Suite in CSV format for optimization with
          Fields Test Case ID, Test Name, Test Description, Step description,
          Step_Name, Number of Steps, Expected results
        </span>
      </div>
    </div>
    <app-file-upload
      class="mb-2"
      [data]="configs?.file"
      (filesSelected)="handleFilesSelected($event)"
    ></app-file-upload>
  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn-accello-secondary mx-2"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      class="btn-accello-primary-light"
      (click)="upload()"
      [disabled]="isDisabled"
    >
      Add
    </button>
  </div>
</div>
